module.exports = __webpack_public_path__ + "static/Homepage-Hero3-8b634c1ee8dde825f52090c532f43ca0.jpg";